import { ContributionValidationResult } from "../types/contributionTypes";

/**
 * Validate employee contribution percentage
 */
export const validateEmployeeContribution = (
  contribution: number,
  benefitLimit: number,
  salary: number
): ContributionValidationResult => {
  const errors: string[] = [];

  if (contribution < 0) {
    errors.push("Contribution percentage cannot be negative");
  }

  if (contribution > 100) {
    errors.push("Contribution percentage cannot exceed 100%");
  }

  if (salary > 0 && benefitLimit > 0) {
    const annualContribution = (contribution / 100) * salary;
    if (annualContribution > benefitLimit) {
      errors.push(
        `Annual contribution would exceed the limit of $${benefitLimit.toFixed(
          2
        )}`
      );
    }
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};

/**
 * Validate beneficiary allocation totals
 */
export const validateBeneficiaryAllocations = (
  allocatedEmployee: number,
  allocatedEmployer: number,
  totalEmployee: number,
  totalEmployer: number
): ContributionValidationResult => {
  const errors: string[] = [];

  if (allocatedEmployee > totalEmployee) {
    errors.push("Employee allocation exceeds available funds");
  }

  if (allocatedEmployer > totalEmployer) {
    errors.push("Employer allocation exceeds available funds");
  }

  if (allocatedEmployee < totalEmployee) {
    const remaining = totalEmployee - allocatedEmployee;
    errors.push(
      `$${remaining.toFixed(2)} in employee funds remains unallocated`
    );
  }

  if (allocatedEmployer < totalEmployer && totalEmployer > 0) {
    const remaining = totalEmployer - allocatedEmployer;
    errors.push(
      `$${remaining.toFixed(2)} in employer funds remains unallocated`
    );
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};

/**
 * Validate that contribution data is complete and ready for submission
 */
export const validateContributionReadiness = (
  employeeContribution: number,
  perPaycheckDeduction: number
): ContributionValidationResult => {
  const errors: string[] = [];

  if (employeeContribution <= 0) {
    errors.push("Please specify your contribution percentage");
  }

  if (perPaycheckDeduction <= 0) {
    errors.push("Please specify your contribution amount");
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};
